import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { translations } from '../utils/translations';
import { useToast } from '../hooks/use-toast';

const LoginPage = () => {
  // Get language from localStorage or default to pt-BR
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'pt-BR';
  });
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();
  const t = translations[language];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Login failed');
      }

      localStorage.setItem('adminToken', data.token);
      navigate('/admin');
    } catch (error) {
      toast({
        title: 'Error',
        description: t.login.error,
        variant: 'destructive'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="mb-8 text-text-muted hover:text-accent-primary"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t.login.backToHome}
        </Button>

        <Card className="feature-card p-8">
          <div className="text-center mb-8">
            <div className="text-3xl font-bold text-accent-primary mb-2">smart-signage.com.br</div>
            <h1 className="h2 mb-2">{t.login.title}</h1>
            <p className="body-md text-text-secondary">{t.login.subtitle}</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block body-md font-medium mb-2">{t.login.email}</label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.login.emailPlaceholder}
                className="input-field"
              />
            </div>

            <div>
              <label className="block body-md font-medium mb-2">{t.login.password}</label>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t.login.passwordPlaceholder}
                className="input-field"
              />
            </div>

            <Button
              type="submit"
              size="lg"
              className="btn-primary w-full"
              disabled={isLoading}
            >
              {isLoading ? '...' : t.login.submit}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;